import React from "react";
import { Link } from "react-router-dom";
import { Button, Header, Icon, Segment } from "semantic-ui-react";

const PageNotFound = () => {
  return (
    <Segment placeholder>
      <Header icon>
        <Icon name="search" />
        Not Found! The page you’re looking for does not exist.
      </Header>
      <Segment.Inline>
        <Button as={Link} to="/" primary>
          Back Home
        </Button>
      </Segment.Inline>
    </Segment>
  );
};

export default PageNotFound;
